import InfoElement from 'components/InfoElement'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DEFAULT_CURRENCY, getDifferenceWithPrecision, getMomentDate, getNumberWithCurrency } from 'utils'

function ClubCardTab({ dateCurrent, store }) {
  const { t: translate } = useTranslation()
  const {
    clubCardsCurrent,
    revenueClubCompared,
    revenueClubCurrent,
    revenueClubPercent,
    revenueCurrent,
    transactionsClubCurrent,
    transactionValueClubCurrent,
    results,
  } = store
  const dateFormatted = dateCurrent ? getMomentDate(dateCurrent).format('L') : '-'
  const currency = (results[0] && results[0].currency) || DEFAULT_CURRENCY

  return (
    <div className="clubcard-details">
      <div className="clubcard-details-date">{dateFormatted}</div>

      <div className="clubcard-details-general flex-row">
        <div className="clubcard-details-general_value first-column flex-row">
          <div className="fm fm-clubcard" />

          <div className="clubcard-details-general_current">
            {getNumberWithCurrency({
              currency,
              number: revenueClubCurrent,
              precision: 0,
              translate,
            })}
          </div>
        </div>

        <InfoElement
          percentDifference={getDifferenceWithPrecision({
            handleNullCase: true,
            number: revenueClubPercent,
            translate,
          })}
        />
      </div>

      {(revenueClubCurrent > 0 || revenueClubCompared > 0) && (
        <div className="flex-row stats">
          <div className="first-column flex-row">{translate('revenue.details.clubCard.shareStoreSale')}:</div>

          <strong>
            {
              getDifferenceWithPrecision({
                number: revenueClubCurrent / revenueCurrent,
                precision: 0,
                translate,
              }).value
            }
          </strong>
        </div>
      )}

      {transactionValueClubCurrent > 0 && (
        <div className="flex-row stats">
          <div className="first-column flex-row">{translate('revenue.details.clubCard.averageTransactionValue')}:</div>

          <strong>
            {getNumberWithCurrency({
              number: transactionValueClubCurrent,
              translate,
              precision: 0,
              currency,
            })}
          </strong>
        </div>
      )}

      {transactionsClubCurrent > 0 && (
        <div className="flex-row stats">
          <div className="first-column flex-row">{translate('revenue.details.clubCard.clubCardTransactions')}:</div>

          <strong>{transactionsClubCurrent}</strong>
        </div>
      )}

      {clubCardsCurrent > 0 && (
        <div className="flex-row stats">
          <div className="first-column flex-row">{translate('revenue.details.clubCard.newCardsOnGivenDay')}:</div>

          <strong>{clubCardsCurrent}</strong>
        </div>
      )}
    </div>
  )
}

ClubCardTab.propTypes = {
  dateCurrent: PropTypes.string,
  store: PropTypes.shape({
    revenueClubCompared: PropTypes.number,
    revenueClubCurrent: PropTypes.number,
    revenueCurrent: PropTypes.number,
    transactionsClubCurrent: PropTypes.number,
    transactionValueClubCurrent: PropTypes.number,
  }).isRequired,
}

export default ClubCardTab
